export enum WebScanState {
    NOT_STARTED = 'not_started',
    INITIALIZING = 'initializing',
    STARTED = 'started',
    FINISHED = 'finished',
}
